import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V1, post } from "../api";
import {  NINData } from "../@types";


function useVerifyNIN(
  options?: MutationOptions<APIResponse<NINData>, APIError, Record<any, any>>,
) {
  const {
    isLoading: verifyingNIN,
    isError: isVerifyingNINError,
    error: verifyingNINError,
    mutate: verifyNIN,
  } = useMutation(async (variables: Record<any, any>) => {
    const res = await post(
      API_URL_V1 + '/kyc/nin/lookup',
      {
        nin: variables.nin || variables.nin_number
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ localStorage.getItem('token')}`,
        },
      },
    ) as APIResponse<any>;

    return {
      ...res,
      data: res.data?.entity || res.data
    };
  }, options);

  return {
    verifyNIN,
    isVerifyingNINError,
    verifyingNINError,
    verifyingNIN,
  };
}

export default useVerifyNIN;